const isRowEmpty = row => Object.values(row).every(value => !value);

const emptyRowsTrimmer = sheetAsJson => {
  const rowEmptiness = sheetAsJson.map(isRowEmpty);
  const lastNonEmptyRowIndex = rowEmptiness.lastIndexOf(false);
  const trimmedRowsList = sheetAsJson.slice(0, lastNonEmptyRowIndex + 1);

  return trimmedRowsList;
};

export default emptyRowsTrimmer;
